/**
 * Browser detection utilities for handling platform-specific behaviors
 */

/**
 * Detects if the current browser is Chrome on mobile
 */
export function isMobileChrome(): boolean {
  const userAgent = navigator.userAgent
  return /Chrome/.test(userAgent) && /Mobile/.test(userAgent)
}

/**
 * Detects if the current device is mobile (any mobile browser)
 */
export function isMobile(): boolean {
  return /Mobile|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

/**
 * Checks if the browser supports the Page Visibility API
 */
export function supportsPageVisibility(): boolean {
  return typeof document.visibilityState !== 'undefined'
}

/**
 * Checks if the browser supports the Network Information API
 */
export function supportsNetworkInformation(): boolean {
  return 'connection' in navigator
}